var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEquity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.795898,
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_radial_6003_1187)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8754 19.5459H15.3754M20.6254 19.5459H25.1254M18.0004 15.0459V25.5459M18.0004 15.0459C19.0359 15.0459 19.8754 14.2064 19.8754 13.1709M18.0004 15.0459C16.9648 15.0459 16.1254 14.2064 16.1254 13.1709M12.0004 25.5459L24.0004 25.5459M12.0004 13.1709L16.1254 13.1709M16.1254 13.1709C16.1254 12.1354 16.9648 11.2959 18.0004 11.2959C19.0359 11.2959 19.8754 12.1354 19.8754 13.1709M19.8754 13.1709L24.0004 13.1709M15.6607 20.5482C15.3602 21.6988 14.3389 22.5459 13.1254 22.5459C11.9118 22.5459 10.8905 21.6988 10.59 20.5482C10.5655 20.4541 10.5532 20.4071 10.552 20.2193C10.5513 20.1042 10.5941 19.8387 10.6309 19.7296C10.6911 19.5516 10.7562 19.4512 10.8864 19.2503L13.1254 15.7959L15.3643 19.2503C15.4945 19.4512 15.5596 19.5516 15.6198 19.7296C15.6566 19.8387 15.6994 20.1042 15.6987 20.2193C15.6975 20.4071 15.6852 20.4541 15.6607 20.5482ZM25.4107 20.5482C25.1102 21.6988 24.0889 22.5459 22.8754 22.5459C21.6618 22.5459 20.6405 21.6988 20.34 20.5482C20.3155 20.4541 20.3032 20.4071 20.302 20.2193C20.3013 20.1042 20.3441 19.8387 20.3809 19.7296C20.4411 19.5516 20.5062 19.4512 20.6364 19.2503L22.8754 15.7959L25.1143 19.2503C25.2445 19.4512 25.3096 19.5516 25.3698 19.7296C25.4066 19.8387 25.4494 20.1042 25.4487 20.2193C25.4475 20.4071 25.4352 20.4541 25.4107 20.5482Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6003_1187",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1354 36.7959) rotate(-12.8654) scale(31.9054 30.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD79E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7928FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquity);
export default __webpack_public_path__ + "static/media/equity.549c9bbefac45475813767b85c924289.svg";
export { ForwardRef as ReactComponent };